<script setup>
import {
  ref,
  watch,
  onMounted,
} from 'vue';
import IDateRangePicker from '@components/IDateRangePicker/IDateRangePicker.vue';
import useSiteStore from '@vueApp/store/modules/site';
import IFilterPicker from '@components/IFilterPicker/IFilterPicker.vue';

const siteStore = useSiteStore();

const filterModel = ref({
  units: [],
  noms: [],
  dateRange: [],
  selectTypes: [],

});

const nomsOptions = ref([
  { label: 'КХЛ', value: 10 },
]);

function getDateRangeParam() {
  if (!filterModel.value.dateRange[0]) return [];
  return `${filterModel.value.dateRange[0]} — ${filterModel.value.dateRange[1]}`;
}

function applyFilter() {
  siteStore.setSelectTypes(filterModel.value.selectTypes);
  const searchParams = {
    dateRange: getDateRangeParam(),
    objectTags: filterModel.value.units,
  };
  siteStore.searchEvents({ searchParams });
  siteStore.searchSubscriptions({ searchParams });
}

watch(filterModel.value, () => applyFilter());

onMounted(() => {
  if (nomsOptions.value[0]) {
    filterModel.value.noms.value = nomsOptions.value[0]?.value;
    applyFilter();
  }
});
</script>

<template>
  <meta
    name="viewport"
    content="width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no"
  >
  <div class="events__filter">
    <div class="container">
      <div
        class="filter-wrapper flex-column flex-lg-row align-items-start align-items-lg-center flex-wrap"
      >
        <i-date-range-picker
          v-model="filterModel.dateRange"
          class="filter-date w-100 w-lg-25 mt-lg-0"
        />
        <div class="filter-container">
          <i-filter-picker
            v-model="filterModel.noms"
            :options="nomsOptions"
          />
          <a href="https://tickets.hc-avto.ru/" target="_blank">
            <button class="filter-button">ВХЛ</button>
          </a>
          <a href="https://tickets.hc-avto.ru/" target="_blank">
            <button class="filter-button">МХЛ</button>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@vueform/multiselect/themes/default.css";

.events-filter {
  margin-top: -48px;

  @media (max-width: $screen-xs) {
    margin-top: 0;
  }
}

.filter-wrapper {
  display: flex;

  @media (max-width: $screen-xs) {
    margin-left: -15px;
    margin-right: -15px;
  }
}

.i-filter {
  &__icon {
    transition: transform 0.3s;
    &.active {
      transform: rotate(-180deg);
    }
  }
}

.filter-date {
  margin-right: 56px;
}
</style>
